import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacidadPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
        <button onClick={() => navigate(-1)} className="text-sm text-zl-orange mb-4 hover:underline">&larr; Volver</button>
        <h1 className="text-2xl sm:text-3xl font-bold mb-6">Aviso de Privacidad</h1>
        <div className="bg-white rounded-lg p-6 sm:p-8 space-y-6 text-sm text-gray-700 leading-relaxed">
          <p className="text-gray-500">Ultima actualizacion: Marzo 2026</p>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Responsable del Tratamiento</h2>
          <p><strong>TrendyShop de Mexico S. de R.L. de C.V.</strong>, con domicilio en Ciudad de Mexico, Mexico, es responsable del tratamiento de sus datos personales, en cumplimiento con la Ley Federal de Proteccion de Datos Personales en Posesion de los Particulares (LFPDPPP).</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Datos que Recopilamos</h2>
          <p>Recopilamos: nombre, correo electronico, telefono, direccion de envio, datos de ubicacion (con consentimiento), historial de compras y busquedas dentro de la plataforma.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Finalidad del Tratamiento</h2>
          <p>Sus datos son utilizados para: (a) gestionar su cuenta; (b) procesar compras y envios; (c) mejorar la experiencia de usuario; (d) enviar comunicaciones comerciales (con consentimiento); (e) cumplir obligaciones legales y fiscales.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Derechos ARCO</h2>
          <p>Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, contacte a <strong>privacidad@zonalibre.mx</strong>.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Transferencia de Datos</h2>
          <p>No compartimos sus datos personales con terceros, salvo que sea necesario para completar transacciones (como datos de envio a transportistas) o por requerimiento de autoridad competente.</p></section>

          <p className="text-xs text-gray-400 border-t pt-4">TrendyShop de Mexico S. de R.L. de C.V. — Propietaria de la marca Zona Libre</p>
        </div>
      </div>
    </div>
  );
}
